<template>
  <div
    class="relative inline-block w-10 align-middle select-none transition duration-200 ease-in"
  >
    <input
      type="checkbox"
      :name="name"
      :id="name"
      v-on="$listeners"
      :checked="!!value"
      @change="$emit('update', $event.target.checked)"
    />

    <label :for="name"> {{ label }} </label>
  </div>
</template>

<script>
export default {
  props: ["value", "name", "label"],
  model: {
    prop: "value",
    event: "update",
  },
  methods: {
    updateInput() {
      this.$emit("change", this.value);
    },
  },
};
</script>
